<div class="ir-item-line th-filter">
  <div (click)="setOrderBy('inspection.startDate')" class="ir-item-cell s2 clickable">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      Date
    </span>
  </div>
  <div (click)="setOrderBy('inspection.customerName')" class="ir-item-cell s4 clickable active">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'common.name' | translate }}
    </span>
  </div>
  <div (click)="setOrderBy('inspection.technicianName')" class="ir-item-cell s2 clickable">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      FST
    </span>
  </div>
  <div (click)="setOrderBy('prog')" class="ir-item-cell s2 clickable right">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      Progession
    </span>
  </div>
</div>
<div class="ir-content-flow has-filter">
  <div
    class="ir-item-line th-inspection clickable"
    (click)="selectActionPlan(actionPlan)"
    *ngFor="let actionPlan of actionPlans | orderBy: orderByFieldName:direction | searchBy: query"
  >
    <div class="ir-item-cell s2">
      <span>{{ actionPlan?.etag | formatDate }}</span>
    </div>
    <div class="ir-item-cell s4">
      <span>{{ actionPlan?.inspection?.customerName }}, {{ actionPlan?.inspection?.data?.customer?.Country }}</span>
    </div>
    <div class="ir-item-cell s2">
      <span>{{ actionPlan?.inspection?.technicianName }}</span>
    </div>
    <div class="ir-item-cell s2 right">
      <span>{{ actionPlan?.prog }} %</span>
    </div>
  </div>
  <div class="ir-item-empty ir-mv8" *ngIf="actionPlans?.length == 0">
    <p>
      <span>{{ 'actionplans.no-action-plans' | translate }}</span>
    </p>
  </div>
</div>
<!-- End content flow -->
